<div class=" mb-3 p-1">
    <div class="row">
        <div class="col-sm-4">
            <button *ngIf="!isDashboard" type="button" class="btn btn-navigation me-2" (click)="returnToSummary()"><i
                    class="fas fa-arrow-left"></i> All {{observationTypeName}}{{pluralizeObservationType ?
                "s":""}}</button>
            <button *ngIf="isDashboard" type="button" class="btn btn-navigation me-2" (click)="returnToDashboard()"><i
                    class="fas fa-arrow-left"></i> {{observationTypeName}} Dashboard</button>
        </div>

        <div class="col-sm-4">
            <div class="h3 text-center">
                <span class="fw-bold">{{title ?? observationSummary?.itemName ?? observationTypeName}}</span>
                ({{observationSchoolYear}})
            </div>
            <div class="text-center sm-6">
                <span><b>Evaluator</b>: {{observationEvaluator}} </span><span class="ps-5"><b>Date:</b> {{createdDate |
                    date: "M/d/yyyy"}}</span>
            </div>
            <div class="text-center m-1">
                <span *ngIf="rubricLanguageLink!=''" class="pe-5">
                    <a [href]="rubricLanguageLink" target="_blank">View Framework {{frameworkLabel}}</a></span>
                <span *ngIf="guidanceLink != ''">
                    <a [href]="guidanceLink" target="_blank">Guide to {{observationTypeName}}</a></span>
            </div>

        </div>

        <div class="col-sm-4" style="display: flex;flex-direction: row;flex-wrap: wrap;justify-content: flex-end;">
            <!-- <app-observation-actions class="float-end ms-2" [iconVisible]="true" [editEnabled]="false"
                [deleteEnabled]="false" [emailEnabled]="false" [printEnabled]="true" [attachmentsEnabled]="true"
                [attachmentsCount]="observationFiles.length" [isInsideObservation]="true"
                (click)="$event.stopPropagation()" [observationSummary]="observationSummary"
                (refreshListing)="refreshListing()"></app-observation-actions> -->

            <observation-nudge class="float-end ms-2" [observationSummary]="observationSummary"></observation-nudge>

            <app-observation-print class="float-end ms-2"
                [observationId]="this.observationId ?? this.observationSummary?.observationId"
                [observationType]="observationType"
                [targetUserId]="observationSummary?.targetUser?.userID"></app-observation-print>

            <observation-attachments class="float-end ms-2" *permissionsAll="[PermissionTypes.FILE_ATTACHMENTS]"
                [observationFiles]="observationFiles"
                [observationSummary]="observationSummary"></observation-attachments>

        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div *ngIf="additionalInformation != ''" class="text-center m-1" style="font-size: .9em;">
                {{additionalInformation}}
            </div>
        </div>
    </div>
</div>